import React, { useState, useEffect } from 'react';
import { API } from '../../../../../API/API';
import { Panel, PanelType } from '@fluentui/react';
import Warning from '../../../../../components/Warning/Warning';
import ButtonSecondary from '../../../../../components/ButtonSecondary/ButtonSecondary';
import ButtonDefault from '../../../../../components/ButtonDefault/ButtonDefault';
import FieldDropdown from '../../../../../components/FieldDropdown/FieldDropdown';
import FieldText from '../../../../../components/FieldText/FieldText';
import FieldNumber from '../../../../../components/FieldNumber/FieldNumber';
import { message } from 'antd';
import { MessageConst } from '../../../../../const/MessageConst';
import { hideLoadScreen, showLoadScreen } from '../../../../../components/LoadScreen/LoadScreen';
import PanelBase from '../../../../../components/PanelBase/PanelBase';
import FieldItemListAdd from '../../../../../components/FieldItemListAdd/FieldItemListAdd';

const NewLang = (props) => {
    const [initData, setInitData] = useState({
        "entryid": -1,
        "empid": props.empid,
        "forlanguageid": null,
        "studytime": null,
        "listeninglevelid": null,
        "speakinglevelid": null,
        "readinglevelid": null,
        "writinglevelid": null,
        "ieltsscore": null,
        "toeflscore": null
    });
    const [data, setData] = useState({ ...initData });
    const [dLevel, setDLevel] = useState([]);
    const [warning, setWarning] = useState();

    const getInitData = async () => {

        let tDLevel = [];

        showLoadScreen();

        await API.get('/api/humanresource/organization/get_forlanguagelevel_dropdown').then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                tDLevel = response.data.retdata;
            }
        });
        hideLoadScreen();

        setDLevel(tDLevel);
    }

    useEffect(() => {
        getInitData();
    }, []);

    const getExistData = async () => {
        let tData = { ...initData };
        if (props.entryid) {

            showLoadScreen();
            await API.get('/api/humanresource/employee/get_empforlanguage?entryid=' + props.entryid).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    if (response.data?.retdata?.length > 0) {
                        tData = response.data.retdata[0];

                    }
                }
            });
            hideLoadScreen();

        }

        setData(tData);
    }

    useEffect(() => {
        getExistData();
    }, [props.entryid]);

    const fieldOnChanged = (key, text, field, fieldname) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            if (fieldname) {
                tData[fieldname] = text;
            }
            setData(tData);
        }

    }

    const onSave = async (p_close) => {

        let vRule = true;
        if (!data.forlanguageid) {
            vRule = false;
            setWarning("Гадаад хэл" + MessageConst.fieldRequired);
        }

        if (vRule) {
            showLoadScreen();
            let tData = { ...data };
            tData.empid = props.empid;
            await API.post('/api/humanresource/employee/save_empforlanguage', [tData]).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    message.success(MessageConst.success);
                    setData({ ...initData });
                    setWarning();
                    if (props.afterSave) {
                        props.afterSave(p_close);
                    }
                }
            });
            hideLoadScreen();
        }
    }
    const onDelete = async (p_close) => {
        showLoadScreen();
        await API.post('/api/humanresource/employee/delete_empforlanguage?entryid=' + props.entryid).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                message.success(MessageConst.success);
                if (props.afterSave) {
                    props.afterSave(p_close);
                }
            }
        });
        hideLoadScreen();
    }

    return (
        <PanelBase
            headerText={props.entryid > 0 ? "Хэлний мэдлэг засах" : "Хэлний мэдлэг нэмэх"}
            isOpen={props.onOpen}
            type={PanelType.medium}
            isFooterAtBottom={true}
            onDismiss={props.onDismiss}
            onDelete={() => onDelete(true)}
            warning={warning}
            delete={props.entryid}
            buttons={
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div>
                        <ButtonSecondary onClick={() => onSave(false)} text="Хадгалаад шинэ" />
                    </div>
                    <div style={{ marginLeft: 16 }}>
                        <ButtonDefault onClick={() => onSave(true)} text="Хадгалах" />
                    </div>
                </div>
            }
        >
            <div style={{ marginTop: 20 }}>
                <FieldItemListAdd title="Гадаад хэл" onChanged={fieldOnChanged} keyfield='forlanguageid' keyfieldname='forlanguagename' defaultValue={[{ key: data.forlanguageid, name: data.forlanguagename }]} dataurl="/api/humanresource/organization/get_forlanguage_dropdown" saveurl="/api/humanresource/organization/save_forlanguage" />
                <div style={{ marginTop: 13 }}>
                    <FieldDropdown title="Уншиж ойлгох" onChanged={fieldOnChanged} keyfield='readinglevelid' defaultValue={data.readinglevelid} data={dLevel} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDropdown title="Бичиж орчуулах" onChanged={fieldOnChanged} keyfield='writinglevelid' defaultValue={data.writinglevelid} data={dLevel} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDropdown title="Ярьсныг ойлгох" onChanged={fieldOnChanged} keyfield='listeninglevelid' defaultValue={data.listeninglevelid} data={dLevel} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDropdown title="Өөрөө ярих" onChanged={fieldOnChanged} keyfield='speakinglevelid' defaultValue={data.speakinglevelid} data={dLevel} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldNumber title="Үзсэн хугацаа /сараар/" onChanged={fieldOnChanged} keyfield='studytime' defaultValue={data.studytime} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldText title="IELTS оноо" onChanged={fieldOnChanged} keyfield='ieltsscore' defaultValue={data.ieltsscore} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldText title="TOEFL оноо " onChanged={fieldOnChanged} keyfield='toeflscore' defaultValue={data.toeflscore} />
                </div>
            </div>
        </PanelBase>

    );
}

export default NewLang;